import { render, staticRenderFns } from "./QuestionTemplateModal.vue?vue&type=template&id=06f6118c&scoped=true"
import script from "./QuestionTemplateModal.vue?vue&type=script&lang=js"
export * from "./QuestionTemplateModal.vue?vue&type=script&lang=js"
import style0 from "./QuestionTemplateModal.vue?vue&type=style&index=0&id=06f6118c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f6118c",
  null
  
)

export default component.exports